import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag } from "@/utilities/ApplyDrag";
import Loader from "@/components/widgets/loader.vue";
import { PAStepModule } from "@/store/modules/paStep.module";
let OrderStepsComponent = /** @class */ (() => {
    let OrderStepsComponent = class OrderStepsComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.dropPlaceholderOptions = {
                className: "drop-preview",
                animationDuration: "150",
                showOnTop: false,
            };
        }
        get availableSteps() {
            return PAStepModule.steps;
        }
        onDropStep(collection, dropResult) {
            if (dropResult.removedIndex !== null && dropResult.addedIndex !== null) {
                const updatedCollection = [...this[collection]];
                this[collection] = applyDrag(updatedCollection, dropResult);
            }
        }
        SaveOrderedStep() {
            this.orderSteps.forEach((step, index) => {
                step.defaultStepOrder = index + 1;
            });
            this.$emit("saveurderedstep", this.orderSteps);
            this.$emit("closemodal");
        }
        getOrderStepsPayload(index) {
            return this.orderSteps[index];
        }
        closeOrderStepsModal() {
            this.$emit("closemodal");
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], OrderStepsComponent.prototype, "orderSteps", void 0);
    OrderStepsComponent = __decorate([
        Component({
            name: "OrderStepsComponent",
            components: {
                Loader,
                Container,
                Draggable,
            },
        })
    ], OrderStepsComponent);
    return OrderStepsComponent;
})();
export default OrderStepsComponent;
